<template>
  <div class="tabs-view">
    <el-tabs
      v-model="currentActiveTab"
      type="card"
      closable
      @tab-remove="handleTabRemove"
      @tab-click="handleTabClick"
      class="page-tabs"
    >
      <el-tab-pane
        v-for="tab in tabs"
        :key="tab.path"
        :label="tab.title"
        :name="tab.path"
        :closable="tab.closable"
      >
        <template #label>
          <span class="tab-label">{{ tab.title }}</span>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useTabs } from '@/composables/useTabs'

const router = useRouter()
const route = useRoute()
const { tabs, activeTab, removeTab } = useTabs()

// 当前激活的标签页（用于 el-tabs 组件）
const currentActiveTab = computed({
  get: () => activeTab.value,
  set: (val) => {
    activeTab.value = val
  }
})

// 处理标签页移除
const handleTabRemove = (targetPath) => {
  removeTab(targetPath)
}

// 处理标签页点击
const handleTabClick = (tab) => {
  const targetPath = tab.paneName
  if (targetPath && targetPath !== route.path) {
    router.push(targetPath)
  }
}

// 监听路由变化，同步激活的标签页
watch(
  () => route.path,
  (newPath) => {
    if (newPath !== '/login') {
      activeTab.value = newPath
    }
  },
  { immediate: true }
)
</script>

<style scoped>
.tabs-view {
  position: relative;
  z-index: 100;
  flex-shrink: 0;
  background-color: #fff;
  border-bottom: 1px solid #e4e7ed;
  padding: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.page-tabs {
  margin: 0;
}

:deep(.el-tabs__header) {
  margin: 0;
  border-bottom: 1px solid #e4e7ed;
}

:deep(.el-tabs__nav) {
  border: none;
}

:deep(.el-tabs__item) {
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  border: 1px solid #e4e7ed;
  border-bottom: none;
  margin-right: 4px;
  background-color: #f5f7fa;
  color: #606266;
  cursor: pointer;
  user-select: none;
}

:deep(.el-tabs__item:hover) {
  color: #409EFF;
}

:deep(.el-tabs__item.is-active) {
  background-color: #fff;
  color: #409EFF;
  border-bottom-color: #fff;
  position: relative;
  z-index: 1;
}

:deep(.el-tabs__item .el-icon-close) {
  margin-left: 8px;
  font-size: 12px;
}

:deep(.el-tabs__item .el-icon-close:hover) {
  background-color: #c0c4cc;
  color: #fff;
  border-radius: 50%;
}

.tab-label {
  display: inline-block;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

